// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__8OScW","meals-appear":"AvailableMeals_meals-appear__i2xZL","loading":"AvailableMeals_loading__e9jRJ"};